<template>
  <div class="hotel-room">
    <button v-if="clearable" @click="onRoomDelete" type="button" class="hotel-room__delete">
      <img src="@/assets/img/clear-small-gray-icon.svg" alt="">
    </button>
    <div class="hotel-room__wrapper">
      <app-room-icon :accomodation_type="accomodation_type" :disabled="true" />
      <div class="hotel-room__name">#{{ count }} {{ name }}</div>
    </div>
    <div v-if="price" class="hotel-room__price">{{ price }} $</div>
    <div v-if="clients && clients.length" class="hotel-room__clients">
      <div v-for="(client, index) in clients" :key="index" class="hotel-room__client">
        <img v-if="client.age_type" :src="require(`@/assets/img/${client.age_type}-icon.svg`)" alt="">
        <img v-else src="@/assets/img/age-null-icon.svg" alt="">
        <span>{{ client.first_name }} {{ client.last_name || '' }}</span>
      </div>
    </div>
    <div v-if="show_times" class="hotel-room__times" :style="{ pointerEvents: only_select ? 'none' : 'auto' }">
      <app-checkbox
        v-model="times.early_check_in"
        @change="onChangeEarlyCheckIn"
        label="Early"
        :readonly="readonly_check_in || only_select"
      />
      <app-form-group
        label="Check-in time"
        label-for="early_check_in_time"
        class="form-group--no-indent"
        required
        label_left
        :disabled="!times.early_check_in"
      >
        <app-input
          @change.native="onChangeEarlyCheckInTime"
          v-model="times.early_check_in_time"
          v-mask="'99:99'"
          placeholder="--:--"
          autocomplete="off"
          id="early_check_in_time"
          name="early_check_in_time"
          @paste.native.prevent
          :error="$v.times.early_check_in_time.$error"
          :disabled="!times.early_check_in"
          class="input--65"
          :readonly="readonly_check_in || only_select"
        />
        <template #error>
          <div v-if="$v.times.early_check_in_time.$dirty && !$v.times.early_check_in_time.timeRegex">Wrong time</div>
        </template>
      </app-form-group>
      <app-checkbox
        v-model="times.late_check_out"
        @change="onChangeLateCheckOut"
        label="Late"
        :readonly="readonly_check_out || only_select"
      />
      <app-form-group
        label="Check-out time"
        label-for="late_check_out_time"
        class="form-group--no-indent"
        required
        label_left
        :disabled="!times.late_check_out"
      >
        <app-input
          @change.native="onChangeLateCheckOutTime"
          v-model="times.late_check_out_time"
          v-mask="'99:99'"
          placeholder="--:--"
          autocomplete="off"
          id="late_check_out_time"
          name="late_check_out_time"
          @paste.native.prevent
          :error="$v.times.late_check_out_time.$error"
          :disabled="!times.late_check_out"
          class="input--65"
          :readonly="readonly_check_out || only_select"
        />
        <template #error>
          <div v-if="$v.times.late_check_out_time.$dirty && !$v.times.late_check_out_time.timeRegex">Wrong time</div>
        </template>
      </app-form-group>
    </div>
    <div
      v-if="(is_general_manager || is_sales_manager) && ((multiple_clients && multiple_clients.length) || (selected_clients && selected_clients.length))"
      class="hotel-room__multiple"
    >
      <app-select
        @input="onChangeSelect"
        v-model="selected_clients"
        :options="multiple_clients"
        :clearable="false"
        :selectable="onCalcPaxLimit"
        :closeOnSelect="false"
        label="full_name"
        multiple
        placeholder="Selected clients"
      >
        <template #custom-option="option">
          <img v-if="option.age_type" :src="require(`@/assets/img/${option.age_type}-icon.svg`)" alt="" class="select__img">
          <img v-else src="@/assets/img/age-null-icon.svg" alt="">
          {{ option.full_name }}
        </template>
      </app-select>
    </div>
  </div>
</template>

<script>
import AppRoomIcon from '@/components/AppRoomIcon.vue'
import { helpers } from 'vuelidate/lib/validators'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'AppHotelRoom',
  components: { AppRoomIcon },
  props: {
    room: Object,
    clients: Array,
    multiple_clients: Array,
    name: String,
    room_type: String,
    price: Number,
    accomodation_type: Object,
    hotel: Object,
    id: {
      type: Number,
      default: 0
    },
    clearable: {
      type: Boolean,
      default: false
    },
    reservation_clients: {
      type: Array,
      default: () => { return [] }
    },
    show_times: {
      type: Boolean,
      default: false
    },
    readonly_check_in: {
      type: Boolean,
      default: false
    },
    readonly_check_out: {
      type: Boolean,
      default: false
    },
    selected_check_in_time: {
      type: String,
      default: ''
    },
    selected_check_out_time: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 1
    },
    only_select: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected_clients: [],
      times: {
        early_check_in: false,
        early_check_in_time: '',
        late_check_out: false,
        late_check_out_time: ''
      }
    }
  },
  validations: {
    times: {
      early_check_in_time: { timeRegex },
      late_check_out_time: { timeRegex },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
  },
  watch: {
    name: {
      handler() {
        if (this.hotel) {
          this.times.early_check_in_time = this.hotel.check_in
          this.times.late_check_out_time = this.hotel.check_out
          this.times.early_check_in = false
          this.times.late_check_out = false
        }
      },
      immediate: true,
    }
  },
  created() {
    if (this.reservation_clients.length) this.selected_clients = this.reservation_clients
    if (this.hotel) this.selected_clients = this.reservation_clients
    if (this.selected_check_in_time) {
      this.times.early_check_in_time = this.selected_check_in_time
      this.times.early_check_in = true
    }
    if (this.selected_check_out_time) {
      this.times.late_check_out_time = this.selected_check_out_time
      this.times.late_check_out = true
    }
  },
  methods: {
    onChangeEarlyCheckInTime() {
      this.$v.times.early_check_in_time.$touch()
      this.$emit('onChangeEarlyCheckInTime', this.times.early_check_in_time)
    },
    onChangeLateCheckOutTime() {
      this.$v.times.late_check_out_time.$touch()
      this.$emit('onChangeLateCheckOutTime', this.times.late_check_out_time)
    },
    onChangeEarlyCheckIn() {
      if (this.times.early_check_in) this.times.early_check_in_time = null
      else this.times.early_check_in_time = this.hotel.check_in
    },
    onChangeLateCheckOut() {
      if (this.times.late_check_out) this.times.late_check_out_time = null
      else this.times.late_check_out_time = this.hotel.check_out
    },
    onCalcPaxLimit() {
      if (this.accomodation_type && this.selected_clients) {
        return this.selected_clients.length < this.accomodation_type.pax
      }
    },
    onChangeSelect() {
      this.$emit('onChangeRoomClients', this.selected_clients)
    },
    onRoomDelete() {
      this.$emit('onRoomDelete')
    }
  }
}
</script>

<style lang="sass" scoped>
.hotel-room
  position: relative
  padding: 10px
  border: 1px solid #eaeaea
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff

.hotel-room__wrapper
  display: flex
  justify-content: flex-start
  align-items: center
  gap: 10px

.hotel-room__name
  font-weight: 500

.hotel-room__type
  color: #5f5f5f

.hotel-room__clients
  display: flex
  align-items: center
  gap: 20px
  margin-top: 10px
  padding-left: 10px

.hotel-room__client
  display: flex
  align-items: center
  gap: 10px

  span
    color: #5f5f5f
    font-size: 13px
    transform: translateY(1px)

.hotel-room__delete
  position: absolute
  top: 0
  right: 0
  padding: 10px
  line-height: 0

.hotel-room__multiple
  margin-top: 10px

.hotel-room__price
  position: absolute
  right: 10px
  top: 50%
  transform: translateY(-50%)
  font-weight: 500

.hotel-room__times
  display: grid
  grid-template-columns: 70px 200px 65px 180px
  align-items: center
  margin-top: 8px

</style>
